function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import morphdom from 'morphdom';
var activeElement;
var inputTags = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true
};
var mutableTags = {
  INPUT: true,
  TEXTAREA: true,
  OPTION: true
};
var textInputTypes = {
  'datetime-local': true,
  'select-multiple': true,
  'select-one': true,
  color: true,
  date: true,
  datetime: true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  textarea: true,
  time: true,
  url: true,
  week: true
}; // Indicates if the passed element is considered a text input.
//

var isTextInput = function isTextInput(element) {
  return inputTags[element.tagName] && textInputTypes[element.type];
}; // Assigns focus to the appropriate element... preferring the explicitly passed selector
//
// * selector - a CSS selector for the element that should have focus
//


var assignFocus = function assignFocus(selector) {
  var element = selector && selector.nodeType === Node.ELEMENT_NODE ? selector : document.querySelector(selector);
  var focusElement = element || activeElement;
  if (focusElement && focusElement.focus) focusElement.focus();
}; // Dispatches an event on the passed element
//
// * element - the element
// * name - the name of the event
// * detail - the event detail
//


var dispatch = function dispatch(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = {
    bubbles: true,
    cancelable: true,
    detail: detail
  };
  var evt = new CustomEvent(name, init);
  element.dispatchEvent(evt);
  if (window.jQuery) window.jQuery(element).trigger(name, detail);
};

var xpathToElement = function xpathToElement(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}; // Return an array with the class names to be used
//
// * names - could be a string or an array of strings for multiple classes.
//


var getClassNames = function getClassNames(names) {
  return Array(names).flat();
}; // Indicates whether or not we should morph an element
// SEE: https://github.com/patrick-steele-idem/morphdom#morphdomfromnode-tonode-options--node
//


var shouldMorph = function shouldMorph(permanentAttributeName) {
  return function (fromEl, toEl) {
    // Skip nodes that are equal:
    // https://github.com/patrick-steele-idem/morphdom#can-i-make-morphdom-blaze-through-the-dom-tree-even-faster-yes
    if (!mutableTags[fromEl.tagName] && fromEl.isEqualNode(toEl)) return false;
    if (!permanentAttributeName) return true;
    var permanent = fromEl.closest("[".concat(permanentAttributeName, "]")); // only morph attributes on the active non-permanent text input

    if (!permanent && isTextInput(fromEl) && fromEl === activeElement) {
      var ignore = {
        value: true
      };
      Array.from(toEl.attributes).forEach(function (attribute) {
        if (!ignore[attribute.name]) fromEl.setAttribute(attribute.name, attribute.value);
      });
      return false;
    }

    return !permanent;
  };
}; // Morphdom Callbacks ........................................................................................


var DOMOperations = {
  // Navigation ..............................................................................................
  pushState: function pushState(config) {
    var state = config.state,
        title = config.title,
        url = config.url;
    dispatch(document, 'cable-ready:before-push-state', config);
    history.pushState(state || {}, title || '', url);
    dispatch(document, 'cable-ready:after-push-state', config);
  },
  // Notifications ...........................................................................................
  consoleLog: function consoleLog(config) {
    var message = config.message,
        level = config.level;
    level && ['warn', 'info', 'error'].includes(level) ? console[level](message) : console.log(message);
  },
  notification: function notification(config) {
    var title = config.title,
        options = config.options;
    dispatch(document, 'cable-ready:before-notification', config);
    var permission;
    Notification.requestPermission().then(function (result) {
      permission = result;
      if (result === 'granted') new Notification(title || '', options);
      dispatch(document, 'cable-ready:after-notification', _objectSpread(_objectSpread({}, config), {}, {
        permission: permission
      }));
    });
  },
  // Cookies .................................................................................................
  setCookie: function setCookie(config) {
    var cookie = config.cookie;
    dispatch(document, 'cable-ready:before-set-cookie', config);
    document.cookie = cookie;
    dispatch(document, 'cable-ready:after-set-cookie', config);
  },
  // DOM Events ..............................................................................................
  dispatchEvent: function dispatchEvent(config) {
    var element = config.element,
        name = config.name,
        detail = config.detail;
    dispatch(element, name, detail);
  },
  // Element Mutations .......................................................................................
  morph: function morph(detail) {
    activeElement = document.activeElement;
    var element = detail.element,
        html = detail.html,
        childrenOnly = detail.childrenOnly,
        focusSelector = detail.focusSelector,
        permanentAttributeName = detail.permanentAttributeName;
    var template = document.createElement('template');
    template.innerHTML = String(html).trim();
    dispatch(element, 'cable-ready:before-morph', _objectSpread(_objectSpread({}, detail), {}, {
      content: template.content
    }));
    var parent = element.parentElement;
    var ordinal = Array.from(parent.children).indexOf(element);
    morphdom(element, childrenOnly ? template.content : template.innerHTML, {
      childrenOnly: !!childrenOnly,
      onBeforeElUpdated: shouldMorph(permanentAttributeName)
    });
    assignFocus(focusSelector);
    dispatch(parent.children[ordinal], 'cable-ready:after-morph', _objectSpread(_objectSpread({}, detail), {}, {
      content: template.content
    }));
  },
  innerHtml: function innerHtml(detail) {
    activeElement = document.activeElement;
    var element = detail.element,
        html = detail.html,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-inner-html', detail);
    element.innerHTML = html;
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-inner-html', detail);
  },
  outerHtml: function outerHtml(detail) {
    activeElement = document.activeElement;
    var element = detail.element,
        html = detail.html,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-outer-html', detail);
    var parent = element.parentElement;
    var ordinal = Array.from(parent.children).indexOf(element);
    element.outerHTML = html;
    assignFocus(focusSelector);
    dispatch(parent.children[ordinal], 'cable-ready:after-outer-html', detail);
  },
  textContent: function textContent(detail) {
    var element = detail.element,
        text = detail.text,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-text-content', detail);
    element.textContent = text;
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-text-content', detail);
  },
  insertAdjacentHtml: function insertAdjacentHtml(detail) {
    activeElement = document.activeElement;
    var element = detail.element,
        html = detail.html,
        position = detail.position,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-insert-adjacent-html', detail);
    element.insertAdjacentHTML(position || 'beforeend', html);
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-insert-adjacent-html', detail);
  },
  insertAdjacentText: function insertAdjacentText(detail) {
    var element = detail.element,
        text = detail.text,
        position = detail.position,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-insert-adjacent-text', detail);
    element.insertAdjacentText(position || 'beforeend', text);
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-insert-adjacent-text', detail);
  },
  remove: function remove(detail) {
    activeElement = document.activeElement;
    var element = detail.element,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-remove', detail);
    element.remove();
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-remove', detail);
  },
  setFocus: function setFocus(detail) {
    activeElement = document.activeElement;
    var element = detail.element;
    dispatch(element, 'cable-ready:before-set-focus', detail);
    assignFocus(element);
    dispatch(element, 'cable-ready:after-set-focus', detail);
  },
  setProperty: function setProperty(detail) {
    var element = detail.element,
        name = detail.name,
        value = detail.value;
    dispatch(element, 'cable-ready:before-set-property', detail);
    if (name in element) element[name] = value;
    dispatch(element, 'cable-ready:after-set-property', detail);
  },
  setValue: function setValue(detail) {
    var element = detail.element,
        value = detail.value,
        focusSelector = detail.focusSelector;
    dispatch(element, 'cable-ready:before-set-value', detail);
    element.value = value;
    assignFocus(focusSelector);
    dispatch(element, 'cable-ready:after-set-value', detail);
  },
  // Attribute Mutations .....................................................................................
  setAttribute: function setAttribute(detail) {
    var element = detail.element,
        name = detail.name,
        value = detail.value;
    dispatch(element, 'cable-ready:before-set-attribute', detail);
    element.setAttribute(name, value);
    dispatch(element, 'cable-ready:after-set-attribute', detail);
  },
  removeAttribute: function removeAttribute(detail) {
    var element = detail.element,
        name = detail.name;
    dispatch(element, 'cable-ready:before-remove-attribute', detail);
    element.removeAttribute(name);
    dispatch(element, 'cable-ready:after-remove-attribute', detail);
  },
  // CSS Class Mutations .....................................................................................
  addCssClass: function addCssClass(detail) {
    var _element$classList;

    var element = detail.element,
        name = detail.name;
    dispatch(element, 'cable-ready:before-add-css-class', detail);

    (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(getClassNames(name)));

    dispatch(element, 'cable-ready:after-add-css-class', detail);
  },
  removeCssClass: function removeCssClass(detail) {
    var _element$classList2;

    var element = detail.element,
        name = detail.name;
    dispatch(element, 'cable-ready:before-remove-css-class', detail);

    (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(getClassNames(name)));

    dispatch(element, 'cable-ready:after-remove-css-class', detail);
  },
  // Style Mutations .......................................................................................
  setStyle: function setStyle(detail) {
    var element = detail.element,
        name = detail.name,
        value = detail.value;
    dispatch(element, 'cable-ready:before-set-style', detail);
    element.style[name] = value;
    dispatch(element, 'cable-ready:after-set-style', detail);
  },
  setStyles: function setStyles(detail) {
    var element = detail.element,
        styles = detail.styles;
    dispatch(element, 'cable-ready:before-set-styles', detail);

    for (var _i2 = 0, _Object$entries = Object.entries(styles); _i2 < _Object$entries.length; _i2++) {
      var _ref3 = _Object$entries[_i2];

      var _ref2 = _slicedToArray(_ref3, 2);

      var name = _ref2[0];
      var value = _ref2[1];
      element.style[name] = value;
    }

    dispatch(element, 'cable-ready:after-set-styles', detail);
  },
  // Dataset Mutations .......................................................................................
  setDatasetProperty: function setDatasetProperty(detail) {
    var element = detail.element,
        name = detail.name,
        value = detail.value;
    dispatch(element, 'cable-ready:before-set-dataset-property', detail);
    element.dataset[name] = value;
    dispatch(element, 'cable-ready:after-set-dataset-property', detail);
  }
};

var perform = function perform(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    emitMissingElementWarnings: true
  };

  for (var name in operations) {
    if (operations.hasOwnProperty(name)) {
      var entries = operations[name];

      for (var i = 0; i < entries.length; i++) {
        var detail = entries[i];

        try {
          if (detail.selector) {
            detail.element = detail.xpath ? xpathToElement(detail.selector) : document.querySelector(detail.selector);
          } else {
            detail.element = document;
          }

          if (detail.element || options.emitMissingElementWarnings) DOMOperations[name](detail);
        } catch (e) {
          if (detail.element) console.log("CableReady detected an error in ".concat(name, "! ").concat(e.message));else console.log("CableReady ".concat(name, " failed due to missing DOM element for selector: '").concat(detail.selector, "'"));
        }
      }
    }
  }
};

var performAsync = function performAsync(operations) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    emitMissingElementWarnings: true
  };
  return new Promise(function (resolve, reject) {
    try {
      resolve(perform(operations, options));
    } catch (err) {
      reject(err);
    }
  });
};

export default {
  perform: perform,
  performAsync: performAsync,
  isTextInput: isTextInput,
  DOMOperations: DOMOperations
};